/**
 * @Desription: 登录-登录初始化调用方法
 * @Author: netstar.sjj
 * @Date: 2021-10-25 16:05:00
 * @class NSLogin
*/
import loginSubmit from './login-submit';//提交
declare const window: any;

namespace loginManager {
    const $ = window.jQuery;
    const nsAlert = window.nsAlert;
    let config: any = {};
    export const submit = loginSubmit;
    const loginInfo: any = {
        //保存登录页config到本地存储，以方便之后调用
        save: function () {
            let storeConfigStr = JSON.stringify(config);
            window.store.set('NetstarLoginConfig', storeConfigStr);
        },
        //清除登录页config的本地存储
        clear: function () {
            window.store.remove('NetstarLoginConfig');
        }
    }
    const initImages: Function = function () {
        let bgImage: string = config.images.bg;
        let logoImage: string = config.images.logo;
        window.jQuery(config.containerEl).attr('style', "background-image:url(" + bgImage + ")");
        window.jQuery(config.containerEl + ' .logo img').attr('src', logoImage);
    }
    //是否显示手机登录、微信登录、企业微信登录 gst20200518
    //若有需要则在页面的NSLogin.init()中添加hideMobile(是否显示手机登录)和hidewxChat(是否隐藏微信、企业微信登录)参数，true为显示，若不写则默认为true
    const isShow: Function = function () {
        if (config.hideMobile === true) {
            window.jQuery('#mobile').addClass("hide");//是否隐藏手机登录 由于无法找到准确的标签，所以在页面html中添加了一个id
        }
        if (config.hidewxChat === true) {
            window.jQuery('.login-choose').addClass("hide");//是否隐藏微信登录、企业微信登录
        }
    }

    const initWxChatUrl: Function = function () {
        if (config.wxChatEl) {
            window.jQuery(config.wxChatEl).attr('href', 'javascript:NSLogin.loginManger.toWxChatUrl();');
        }
        if (config.wxChatEl) {
            window.jQuery(config.qyWxChatEl).attr('href', 'javascript:NSLogin.loginManger.toQyWxChat();');
        }
    }
    //如果页面是来自于微信登录跳转 url会添加 code 和 state 参数
    ///workweixin/workWeixinUserEmps/login?authCode=xxx&state=xxx 返回token
    const loginByScan: Function = function () {
        let loginUrlParams: any = window.NSUtils.getUrlPara();
        //微信获取token登录 tempToken为钉钉单点登录的token（解决掉完钉钉会在调用以下接口问题）
        if (loginUrlParams.code && loginUrlParams.state && !loginUrlParams.loginType && !loginUrlParams.tempToken) {
            window.jQuery.ajax({
                url: window.NSUtils.getAPIUrl() + 'workweixin/weChatLogin/login',
                data: {
                    code: loginUrlParams.code,
                    state: loginUrlParams.state
                },
                type: 'GET',
                success: function (res: any) {
                    if (res.success == false) {
                        window.nsAlert(window.language.login.scancode.error, 'error');
                        console.error(window.language.login.scancode.error, 'error');
                        return;
                    }
                    window.NSLogin.serverData = res;
                    window.NSLogin.loginRes = res;
                    window.NSLogin.Authorization = res.data.token;
                    window.NSUtils.OAuthCode.set({
                        authorization: window.NSLogin.Authorization,
                        expireMinute: config.expireMinute,
                        loginTimeStamp: new Date().getTime(),
                    });
                    window.NSLogin.toHomePage(window.NSLogin.Authorization);
                },
                error: function (error: any) {
                    window.nsalert(window.language.login.scancode.error, 'error');
                    console.error(window.language.login.scancode.error, 'error');
                }
            })
        }
        //yl 22/09/28 企业微信扫码登录 直接走免密登录认auth_code 故先注释一下代码 后续可根据情况选用
        //企业微信获取token登录 
        // if(loginUrlParams.auth_code && loginUrlParams.state){
        //     window.jQuery.ajax({
        //         url:window.NSUtils.getAPIUrl() + 'workweixin/workWeixinUserEmps/login',
        //         data:{
        //             authCode:loginUrlParams.auth_code,
        //             state:loginUrlParams.state
        //         },
        //         type:'GET',
        //         success:function(res:any){
        //             if(res.success == false){
        //                 window.nsalert(window.language.login.scancode.error, 'error');
        //                 console.error(window.language.login.scancode.error,'error');
        //                 return;
        //             }
        //             window.NSLogin.serverData = res;
        //             window.NSLogin.loginRes = res;
        //             window.NSLogin.Authorization = window.NSLogin.res.data.token;

        //             window.NSUtils.OAuthCode.set({
        //                 authorization:      res.data.token, 
        //                 expireMinute:       config.expireMinute,
        //                 loginTimeStamp:     new Date().getTime(),
        //             });
        //             window.NSLogin.toHomePage(window.NSLogin.Authorization);
        //         },
        //         error:function(error:any){
        //             window.nsalert(window.language.login.scancode.error, 'error');
        //             console.error(window.language.login.scancode.error,'error');
        //         }
        //     })
        // }
    }
    //点击LOGO加入收藏夹功能
    const addFav: Function = function () {
        let href: string = window.location.href; //地址
        let orgname: string = window.jQuery(config.orgnameEl).val(); //组织名称
        let username: string = window.jQuery(config.usernameEl).val(); //帐号
        let enCodeorgname: string = encodeURIComponent(orgname); //组织名称转码
        let enCodeusername: string = encodeURIComponent(username); //帐号名称转码
        if (href.indexOf('?') == -1) {
            let enUrl: string = href + '?orgname=' + enCodeorgname + '&username=' + enCodeusername; //拼成可以存储信息的地址（不包含密码）
            window.open(enUrl);
        } else {
            let endhref: number = href.indexOf('?');
            let newhref: string = href.slice(0, endhref);
            let enUrl: string = newhref + '?orgname=' + enCodeorgname + '&username=' + enCodeusername; //拼成可以存储信息的地址（不包含密码）
            window.open(enUrl);
        }
    }
    const enterEvent: Function = function (event: any) {
        let browser = window.navigator.appName;
        let userAgent = window.navigator.userAgent;
        let code: number;
        if (browser.indexOf('Internet') > -1) {//IE
            code = window.event.keyCode;
        } else if (userAgent.indexOf('Firefox') > -1) {//Firefox
            code = event.which;
        } else {//其他浏览器
            code = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode;
        }
        if (code == 13) {
            window.NSLogin.loginManger.submit();
        }
    }
    export function refreshVerImg() {
        let config: any = window.NSLogin.config;
        let userNameVal: string = window.jQuery(config.usernameEl).val();
        let orgNameVal: string = window.jQuery(config.orgnameEl).val();
        let orgName: string = encodeURIComponent(orgNameVal);
        let userName: string = encodeURIComponent(userNameVal);
        let random: number = Math.random() * 100;
        let verificationImgUrl: string = window.NSUtils.getAPIUrl() + '/verificationCode?' + "orgName=" + orgName + "&" + "username=" + userName + "&random=" + random;
        if(typeof(window.NSSystemConfig)=='object' && typeof(typeof(window.NSSystemConfig.login)=='object')){
            if(window.NSSystemConfig.login.verificateAjax && window.NSSystemConfig.login.verificateAjax.url){
                let verificateAjaxData = typeof(window.NSSystemConfig.login.verificateAjax.data)=='object' ? window.NSSystemConfig.login.verificateAjax.data : {};
                let verificateUrlParamsArr = [];
                if(!window.jQuery.isEmptyObject(verificateAjaxData)){
                    verificateAjaxData = window.NSUtils.getFormatParameterJSON(verificateAjaxData,{organizationName:"",orgName:orgName,username:userName,random:random});
                }
                for(let verifiKeyI in verificateAjaxData){
                    verificateUrlParamsArr.push(verifiKeyI+'='+verificateAjaxData[verifiKeyI]);
                }
                let verificateUrlParamStr = verificateUrlParamsArr.length > 0 ? verificateUrlParamsArr.join('&') : "orgName=" + orgName +"&"+ "username=" +userName+"&random="+random;
                verificationImgUrl = window.NSUtils.getAPIUrl()+window.NSSystemConfig.login.verificateAjax.url+'?'+verificateUrlParamStr;
            }
        }
        let htmlImg: string = '<img class="verification-img-size" src="' + verificationImgUrl + '"><br/><a href="javascript:void(0);" id="refreshVerificationImg">' + window.language.login.verifiyName + '</a>';
        window.jQuery(config.verificationImgEl).html(htmlImg);
        window.jQuery('#refreshVerificationImg').off('click').on('click', window.NSLogin.loginManger.refreshVerImg);
    }
    export const remember: any = {
        set: function () {
            let config: any = window.NSLogin.config;
            let isRemember: boolean = window.jQuery('#remember').prop("checked");
            if (isRemember === true) {
                let orgName: string = window.jQuery(config.orgnameEl).val();
                let userName: string = window.jQuery(config.usernameEl).val();
                let loginRemember: any = {
                    orgName: orgName,
                    userName: userName,
                    remember: true,
                };
                window.store.set('NetstarLoginRemember', loginRemember);
            } else {
                //如果不保存，也需要记录点了不保存
                window.store.set('NetstarLoginRemember', { remember: false });
            }
        },
        //显示到页面输入框里
        get: function () {
            let config: any = window.NSLogin.config;
            let loginRemember: any = window.store.get('NetstarLoginRemember');
            if (typeof (loginRemember) != 'object') {
                loginRemember = {};
            }
            let urlParams: any = window.NSUtils.getUrlPara();
            let orgValues: any = config.orgValues;
            //优先使用url传进来的参数
            let urlOrgName: string = '';
            if (urlParams.orgname && orgValues) {
                if (orgValues[urlParams.orgname]) {
                    urlOrgName = orgValues[urlParams.orgname];
                }
            }
            //如果选择了记录则读取
            if (loginRemember.remember) {
                //读取url中的组织名称 用户名 密码 优先使用url传进来的参数 cy 191113
                if (urlOrgName != '') {
                    //如果url传进来的orgName跟本地存储的不一样则清空userName
                    if (loginRemember.orgName != urlOrgName) {
                        loginRemember.userName = '';
                    }
                    loginRemember.orgName = urlOrgName;
                }
                if (urlParams.username) {
                    loginRemember.userName = urlParams.username;
                }
                if (urlParams.password) {
                    loginRemember.password = urlParams.password;
                }
                window.jQuery(config.orgnameEl).val(loginRemember.orgName);
                window.jQuery(config.usernameEl).val(loginRemember.userName);
                if (loginRemember.password) {
                    window.jQuery(config.passwordEl).val(loginRemember.password);
                }
            } else {
                window.jQuery('#remember').prop("checked", false);
                if (urlOrgName != '') {
                    window.jQuery(config.orgnameEl).val(urlOrgName);
                }
                if (urlParams.username) {
                    window.jQuery(config.usernameEl).val(urlParams.username);
                }
                if (urlParams.password) {
                    window.jQuery(config.passwordEl).val(urlParams.password);
                }
            }
            function saveAutoLoginData(autoLoginData) {
                window.jQuery('#remember').prop("checked", true);
                window.jQuery('#remember').parent().find('p').text('自动登录')
                var showUserInfo = false;
                if (autoLoginData) {
                    window.jQuery(config.orgnameEl).val(autoLoginData.orgName);
                    window.jQuery(config.usernameEl).val(autoLoginData.username);
                    window.jQuery(config.passwordEl).val(autoLoginData.password);
                    //如果有全部信息则自动登录
                    if (autoLoginData.orgName && autoLoginData.username && autoLoginData.password) {
                        // 自动登录，密码不需要再次加密
                        window.NSLogin.loginManger.submit({ passwordIsMD5: false });
                    } else {
                        showUserInfo = true;
                    }
                } else {
                    showUserInfo = true;
                }
                if (showUserInfo == true) {
                    // 自动登录隐藏账号、密码输入框
                    if (window.jQuery(config.containerEl).children('.login').hasClass('hidden')) {
                        window.jQuery(config.containerEl).children('.login').removeClass('hidden')
                    }
                }
            }
            //如果配置了自动登录 则填充用户名密码 APP和移动端分开支持
            if (window.NetstarApiConfig.login && window.NetstarApiConfig.login.appAutoLogin && typeof (window._cordovaNative) == "object") {
                let autoLoginData = window.store.get('appAutoLogin');
                saveAutoLoginData(autoLoginData);
            } else {
                // 如果不是自动登录，并且隐藏账号、密码输入框，需要显示出来账号密码输入
                if (window.jQuery(config.containerEl).children('.login').hasClass('hidden')) {
                    window.jQuery(config.containerEl).children('.login').removeClass('hidden')
                }
            }
            if (typeof (window._cordovaNative) == 'undefined') {
                // 自动登录隐藏账号、密码输入框
                if (window.jQuery(config.containerEl).children('.login').hasClass('hidden')) {
                    window.jQuery(config.containerEl).children('.login').removeClass('hidden')
                }
            }

            if (window.NetstarApiConfig.login && window.NetstarApiConfig.login.mobileAutoLogin && window.NSUtils.getBrowserVersion().browserSystem == "mobile") {
                let autoLoginData = window.store.get('mobileAutoLogin');
                saveAutoLoginData(autoLoginData);
            }
        }
    }
    export function getScanCodeUrl() {
        let regUrls: any = {
            'https://qa.wangxingcloud.com/': 'https://qa.wangxingcloud.com/',
            'https://wangxingcloud.com/': 'https://wangxingcloud.com/',
        };
        let logonUrl = window.location.protocol + '//' + window.location.host;
        if (regUrls[logonUrl]) {
            return logonUrl;
        } else {
            return 'https://qa.wangxingcloud.com/';
        }
    }
    //微信
    export function toWxChatUrl() {
        let config: any = window.NSLogin.config;
        if (typeof (config.wxChatAjax) != 'object') {
            return;
        }
        window.jQuery.ajax({
            url: config.wxChatAjax.url,
            type: "GET",
            data: {
                domain: window.NSLogin.getScanCodeUrl(),
            },
            dataType: 'text',
            success: function (res: any) {
                let wxChaturl: string = res;
                window.open(wxChaturl, "_blank");
            },
            error: function () {
                window.nsalert(window.language.login.wx.error, 'error');
                console.log(window.language.login.wx.error);
            },
        })
    }
    //企业微信
    export function toQyWxChat() {
        let config: any = window.NSLogin.config;
        if (typeof (config.qyWxChatAjax) != 'object') {
            return;
        }
        window.jQuery.ajax({
            url: config.qyWxChatAjax.url,
            type: "GET",
            headers: {
                "content-type": " application/x-www-form-urlencoded"
            },
            dataType: 'json',
            success: function (res: any) {
                if (res.success && res.data && res.data.url) {
                    let url: string = res.data.url.replace("redirect_uri=", "redirect_uri=" + window.NetstarApiConfig.webRootPath);
                    window.open(url, "_blank");
                } else {
                    window.nsalert("未能成功生成连接")
                }

            },
            error: function (err) {
                window.nsalert(window.language.login.wx.error, 'error');
                console.log(window.language.login.wx.error);
            },
        })
    }

    /****************** 钉钉扫码登录 start *******************/
    // 初始化钉钉二维码登录面板，取消导航上的隐藏，并设置直接显示
    const dingtalkQR = {
        // 初始化钉钉二维码登录相关功能
        init: function dingtalkSSOForQR() {
            // 未配置则不需要调用此功能 以下三个条件都满足才可以使用此功能
            if (typeof (window.NetstarApiConfig.dingtalkSSO) == 'object') {
                if (
                    typeof (window.NetstarApiConfig.dingtalkSSO.scanQR) == 'object' &&
                    window.NetstarApiConfig.dingtalkSSO.isUseQR === true
                ) {
                    const isDefaultShow = window.NetstarApiConfig.dingtalkSSO.scanQR.isDefaultShow || false; //是否默认显示钉钉二维码登录(默认不显示)
                    this.initLoginPanel(isDefaultShow);  //初始化登录面板相关
                    this.getLoginJS(function () {
                        dingtalkQR.initQR()
                    }); //先加载钉钉扫码的JS, 再初始化二维码启动监听
                }
                this.setEvent()
            }

        },
        // 初始化钉钉登录面板
        initLoginPanel: function (isDefaultShow) {
            // 默认不显示钉钉登录
            $('#dingding').removeClass('hide');
            if (isDefaultShow) {
                // 默认显示钉钉登录二维码，选中选项并显示面板
                $('#login-tab .tab-nav-item').removeClass('current');  // 登录方式tab全部删除当前选中状态
                $('#dingding').addClass('current');                    // 钉钉登录添加当前选中状态
                $('#login-account').removeClass('current');    // 其他登录面版隐藏
                $('#login-dingding').addClass('current');              // 钉钉二维码面板显示
            }
        },

        // 获取钉钉扫码登录的js
        getLoginJS: function (cb) {
            //已经加载过JS
            if (typeof window.DDLogin == 'function') {
                cb();
                return;
            }
            //未加载过JS
            const ddLoginUrl = 'https://g.alicdn.com/dingding/dinglogin/0.0.5/ddLogin.js';
            $.getScript(ddLoginUrl, function (res, status) {
                if (status != 'success') {
                    window.nsAlert('https://g.alicdn.com/dingding/dinglogin/0.0.5/ddLogin.js 文件加载失败, 无法生成二维码，请检查网络是否', 'error');
                    return;
                }
                cb()
            })
        },

        // 初始化二维码和监听器
        initQR: function () {
            const scanQR = window.NetstarApiConfig.dingtalkSSO.scanQR || {};
            const appId = scanQR.appId;
            const redirectUri = window.location.origin;
            const goto = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appId}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${encodeURIComponent(redirectUri)}`;

            //在登录面板容器的容器中初始化二维码
            const qrContainerId = "dingding-login-container";
            window.DDLogin({
                id: qrContainerId,
                goto: goto,
                style: "border:none;background-color:#FFFFFF;",
                width: "365",
                height: "300"
            });

            //加载监听器,用户扫码后触发此监听，获取到临时code后刷新页面换取用户code
            window.addEventListener('message', function (ev) {
                const origin = ev.origin;
                if (origin === "https://login.dingtalk.com") {
                    const loginTmpCode = ev.data;
                    window.nsAlert('钉钉扫码登录成功，正在跳转页面');
                    const url = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appId}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${encodeURIComponent(redirectUri)}/&loginTmpCode=${loginTmpCode}`;
                    window.location = url;
                }
            }, false);
        },

        setEvent() {
            // 账号登录、钉钉登录方式点击切换选中
            let $logonTypeTabs = window.jQuery(config.loginTypeTabEl).find('li')
            $logonTypeTabs.off('click')
            $logonTypeTabs.on('click', function (ev: any) {
                var $this = window.jQuery(this);
                $this.siblings().removeClass('current');
                $this.addClass('current');
                var nsId = $this.attr('id');
                switch (nsId) {
                    case 'dingding': //钉钉登录
                        window.jQuery(config.dingTalkEl).addClass('current');
                        window.jQuery(config.dingTalkEl).siblings().removeClass('current');
                        dingtalkQR.init();
                        break;
                    case "mobile": //手机号登录
                        break;
                    default: //账号密码
                        window.jQuery('#login-account').siblings().removeClass('current');
                        window.jQuery('#login-account').addClass('current');
                        break;
                }
            })
        }
    }
    /****************** 钉钉扫码登录 end *******************/


    /**
     * 是否显示验证码
     * 默认登录失败返回登录状态(loginStatus=4)为4，需要显示验证码;
     * 如果配置映射设置了isShowVerificationCode=true, 验证码需要一直显示
     */
    const verificationCode = {
        init: function () {
            let isShowVerificationCode = false;
            if(typeof(window.NetstarApiConfig.login) == 'object'){
                if(typeof(window.NetstarApiConfig.login.isShowVerificationCode) == 'boolean'){
                    isShowVerificationCode = window.NetstarApiConfig.login.isShowVerificationCode;
                }
                this.initVerificationPanel(isShowVerificationCode)
            }
            
        },

        // 初始化二维码面板
        initVerificationPanel:function(_isShowVerificationCode){
            if(_isShowVerificationCode == true){
                let verificationHidden = window.NSLogin.config.verificationHidden; //二维码面板容器
                if(window.jQuery(verificationHidden).length > 0){
                    window.jQuery(verificationHidden).removeClass('hide');
                    this.getVerification();
                }
            }
        },
        // 获取二维码
        getVerification() {
            let config: any = window.NSLogin.config;
            let userNameVal: string = window.jQuery(config.usernameEl).val();
            let orgNameVal: string = window.jQuery(config.orgnameEl).val();
            let orgName: string = encodeURIComponent(orgNameVal);
            let userName: string = encodeURIComponent(userNameVal);
            let random: number = Math.random() * 100;
            let verificationImgUrl: string = window.NSUtils.getAPIUrl() + '/verificationCode?' + "orgName=" + orgName + "&" + "username=" + userName + "&random=" + random;
            let htmlImg: string = '<img class="verification-img-size" src="' + verificationImgUrl + '"><br/><a href="javascript:void(0);" id="refreshVerificationImg">' + window.language.login.verifiyName + '</a>';
            window.jQuery(config.verificationImgEl).html(htmlImg);
            window.jQuery('#refreshVerificationImg').off('click').on('click', window.NSLogin.loginManger.refreshVerImg);
        }
    }
    export function clear() {
        /**
         * 清除登录页面 清除页面上的style  body中的html等
         * 包括  config.styleEl config.containerEl
        */
        let config: any = window.NSLogin.config;
        let $loginContainer: any = window.jQuery(config.containerEl);
        let $loginStyle: any = window.jQuery(config.styleEl);
        $loginContainer.remove();
        $loginStyle.remove();
    }
    export function initPasswordInput() {
        //执行添加显示密码按钮
        let passwordEl = window.NSLogin.config.passwordEl;
        let $passwordInput = document.querySelector(passwordEl);
        if (window.NetstarApiConfig.login && window.NetstarApiConfig.login.isUseShowPasswordBtn == true) {
            //执行添加显示密码按钮
            initShowPasswordBtn();
        } else {
            return;
        }

        //初始化显示密码按钮
        function initShowPasswordBtn() {
            //添加显示密码按钮
            let $passwordBtnContainer = document.createElement('div');
            $passwordBtnContainer.setAttribute('id', 'password-btn-container');
            $passwordBtnContainer.setAttribute('class', 'password-btn-container');
            $passwordBtnContainer.innerHTML = '<i id="password-icon" class="fa-eye"></i>';
            $passwordInput.parentElement.appendChild($passwordBtnContainer);

            let $passwordIcon = document.getElementById('password-icon');
            let isShowPassword = false
            $passwordBtnContainer.addEventListener('click', function (ev) {
                //通过点击切换是否显示密码
                if (isShowPassword == true) {
                    isShowPassword = false;
                    $passwordIcon.setAttribute('class', 'fa-eye');
                    $passwordInput.setAttribute('type', 'password');
                } else {
                    isShowPassword = true;
                    $passwordIcon.setAttribute('class', 'fa-eye-slash');
                    $passwordInput.setAttribute('type', 'text');
                }
            });
        }


    }
    export function init() {
        config = window.NSLogin.config;
        //loginInfo.save();
        initImages();
        isShow();
        dingtalkQR.init(); //钉钉登录初始化
        window.jQuery('.logo img').css('cursor', 'pointer');
        window.jQuery('.logo img').on('click', function () {
            addFav();
        })
        window.jQuery(document).on('keyup', enterEvent);
        remember.get();
        verificationCode.init(); //是否显示验证码
        window.jQuery(config.submitBtnEl).on('click', function (ev: any) {
            config.$login.addClass('login-loading');
            window.NSLogin.loginManger.submit();
        });
        initPasswordInput();
        initWxChatUrl();
        let isUseQR = false; //如果配置钉钉登录，就不需要微信登录
        if (typeof (window.NetstarApiConfig) == 'object' && typeof (window.NetstarApiConfig.dingtalkSSO) == 'object') {
            if (typeof (window.NetstarApiConfig.dingtalkSSO.isUseQR) == 'boolean') {
                isUseQR = window.NetstarApiConfig.dingtalkSSO.isUseQR;
            }
        }
        if (isUseQR == false) {
            loginByScan(); //微信登录
        }
    }
}
export default loginManager;